var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "vuesax/linear/user-tick",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28651"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5a5 5 0 1 1-5-5 5 5 0 0 1 5 5z",
    transform: "translate(7 2)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#8c8d99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M0 7c0-3.87 3.85-7 8.59-7a10.391 10.391 0 0 1 2.76.37",
    transform: "translate(3.41 15)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#8c8d99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M8 4a3.921 3.921 0 0 1-.58 2.06 3.593 3.593 0 0 1-.79.94A3.905 3.905 0 0 1 4 8 3.97 3.97 0 0 1 .58 6.06 3.921 3.921 0 0 1 0 4a4 4 0 0 1 8 0z",
    transform: "translate(14 14)",
    style: {
      stroke: "#1bc47d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "m0 .98.99.99L3.12 0",
    transform: "translate(16.44 17.02)",
    style: {
      stroke: "#1bc47d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.d068f6e2ed96dd66ca7eec4c658c4a86.svg";
export { ForwardRef as ReactComponent };